import React, { lazy } from 'react';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ProtectedRoute from 'src/pages/utility/ProtectedRoute';
import { getCrumb } from 'src/components/MainPage/_shared/Breadcrumbs/Breadcrumb';
import { roleSet } from 'src/constants/role';
import type { AppRoute } from '../types';
import { directoriesTabs } from 'src/pages/registry/DirectoriesPage/DirectoriesTabs';
import { nomenclaturePageLoader } from 'src/pages/registry/NomenclaturesPage/NomenclaturePage/nomenclaturePageLoader';
import { technicalCardPageLoader } from 'src/pages/registry/TechnicalCardPage/technicalCardPageLoader';
import WarehouseIncomesPage from 'src/pages/registry/WarehouseIncomesPage';
import WarehouseIncomePage from 'src/pages/registry/WarehouseIncomePage';
import { warehouseIncomePageLoader } from 'src/pages/registry/WarehouseIncomePage/warehouseIncomePageLoader';
import { nomenclaturesTabs } from 'src/pages/registry/NomenclaturesPage/NomenclaturesTabs';

const NomenclaturesPage = lazy(
  () => import('src/pages/registry/NomenclaturesPage/')
);

const NomenclatureDetailsPage = lazy(
  () => import('src/pages/registry/NomenclaturesPage/NomenclatureDetailsPage')
);

const TechnicalCardsPage = lazy(
  () => import('src/pages/registry/TechnicalCardsPage/')
);

const TechnicalCardPage = lazy(
  () => import('src/pages/registry/TechnicalCardPage/')
);

const DirectoriesPage = lazy(
  () => import('src/pages/registry/DirectoriesPage')
);

const StockBalancePage = lazy(
  () => import('src/pages/registry/StockBalancesPage')
);

export const registryRoutes: AppRoute[] = [
  {
    element: <ProtectedRoute roles={roleSet.financeToSuperAdmin} />,
    handle: {
      label: 'Учёт',
      icon: <MenuBookIcon />,
      roles: roleSet.financeToSuperAdmin,
    },
    children: [
      {
        path: `nomenclatures`,
        handle: {
          crumb: getCrumb('Список номенклатур', true),
        },
        children: [
          {
            index: true,
            element: <NomenclaturesPage />,
            handle: {
              label: 'Номенклатуры',
              roles: roleSet.financeToSuperAdmin,
              nonFranchiseeAccessOnly: true,
            },
          },
          {
            path: ':id',
            element: <NomenclatureDetailsPage />,
            loader: nomenclaturePageLoader,
            children: nomenclaturesTabs,
          },
        ],
      },
      {
        path: `tech-cards`,
        handle: {
          crumb: getCrumb('ТТК', true),
        },
        children: [
          {
            index: true,
            element: <TechnicalCardsPage />,
            handle: {
              label: 'ТТК',
              roles: roleSet.financeToSuperAdmin,
              nonFranchiseeAccessOnly: true,
            },
          },
          {
            path: ':id',
            element: <TechnicalCardPage />,
            loader: technicalCardPageLoader,
          },
        ],
      },
      {
        path: `directories`,
        element: <DirectoriesPage />,
        handle: {
          label: 'Справочники',
          roles: roleSet.financeToSuperAdmin,
          nonFranchiseeAccessOnly: true,
        },
        children: directoriesTabs,
      },
      {
        path: `incomes`,
        handle: {
          crumb: getCrumb('Приёмка на склад', true),
        },
        children: [
          {
            index: true,
            element: <WarehouseIncomesPage />,
            handle: {
              label: 'Приёмка на склад',
              roles: roleSet.financeToSuperAdmin,
              nonFranchiseeAccessOnly: true,
            },
          },
          {
            path: ':id',
            element: <WarehouseIncomePage />,
            loader: warehouseIncomePageLoader,
          },
        ],
      },
      {
        path: `stock-balance`,
        element: <StockBalancePage />,
        handle: {
          label: 'Складской запас',
          roles: roleSet.financeToSuperAdmin,
          nonFranchiseeAccessOnly: true,
        },
      },
    ],
  },
];
